import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/functions";

let env = process.env.NODE_ENV;

var devConfig = {
  apiKey: "AIzaSyB425X5G7Wm_Fptm_H-mplIa04PVf6Z3uI",
  authDomain: "chance-lat-dev.firebaseapp.com",
  projectId: "chance-lat-dev",
  storageBucket: "chance-lat-dev.firebasestorage.app",
  messagingSenderId: "1031421733155",
  appId: "1:1031421733155:web:0ac02454b7074e41410496"
};

var prodConfig = {
  apiKey: "AIzaSyChyu_XX0Wi75YU3M_Hc-YVqESht1PRpMc",
  authDomain: "chance-lat.firebaseapp.com",
  projectId: "chance-lat",
  storageBucket: "chance-lat.firebasestorage.app",
  messagingSenderId: "52767774497",
  appId: "1:52767774497:web:663a6d320825b952db1060",
  measurementId: "G-79D5H2T81N"
};

firebase.initializeApp(env == "production" ? prodConfig : devConfig);

// if (env == "development") {
// firebase.functions().useFunctionsEmulator("http://localhost:5001");
// }

firebase.auth().languageCode = "es";

export const db = firebase.firestore();
export const fb = firebase;

export const FieldValue = firebase.firestore.FieldValue;
